import { Dimmer, Loader } from 'semantic-ui-react'

export const FallbackLoader = () => (
  <Dimmer active>
    <Loader indeterminate>Caricamento...</Loader>
  </Dimmer>
)
